/**
 * The chat runtime's side of Sites (plan 7.10), shared by the web and native
 * runtimes: the artifact context of a site-bound thread, Sites mode, and the
 * draft site made from a Sites-mode page.
 */
import { createSiteDraft } from './sites-api';
import { emitPanelCommands } from './panel-commands';
import { QUERY_KEYS } from './query-keys';
import {
  artifactContextForSend,
  consumeSiteCompose,
  createDraftForSitePage,
} from './site-compose';

export function siteRuntimeParams() {
  return {
    getArtifactContext: (threadId: string | undefined) => artifactContextForSend(threadId),
    consumeSiteMode: () => consumeSiteCompose(),
    onSitePageCreated: (artifactId: string, threadId: string | undefined) => {
      void createDraftForSitePage(
        { artifactId, threadId },
        {
          createDraft: createSiteDraft,
          // The Sites list and the artifact's site refresh wherever they show.
          onCreated: () =>
            emitPanelCommands([{ type: 'data.invalidate', keys: [QUERY_KEYS.SITES] }]),
        },
      );
    },
  };
}
